// Constants
import { INTENTIONAL_NAVIGATION, INTENTIONAL_NAVIGATION_ON } from 'components/header-layout/constants/header-layout.constants';
// Translations
import { TRY_AGAIN } from './translations/contract-error.handlers.translations';
// Types
import {
  ContractErrorBuilderHandlersType,
  ContractErrorHandlersType,
} from './types/contract-error.handlers.type';

const tryAgainOnboardingProcessButtonClickHandler = (): void => {
  localStorage.setItem(INTENTIONAL_NAVIGATION, INTENTIONAL_NAVIGATION_ON);
  window.location.reload();
};

const setupContractErrorButtonConfigurationHandler = ({
  formatMessage,
  setMainButtonConfiguration,
}: ContractErrorBuilderHandlersType): void => {
  setMainButtonConfiguration({
    children: formatMessage({ id: TRY_AGAIN }),
    onClick: () => tryAgainOnboardingProcessButtonClickHandler(),
  });
};

const ContractErrorHandlers = (
  props: ContractErrorBuilderHandlersType
): ContractErrorHandlersType => ({
  handleSetupContractErrorButtonConfiguration: () =>
    setupContractErrorButtonConfigurationHandler(props),
});

export { ContractErrorHandlers };
